import {CanActivateFn} from '@angular/router';
import {environment} from '../../../environments/environment';

export const PORTAL_PROFILE_COMPLETED = 'portalProfileCompleted';

/**
 * Portal initial-onboarding URL that brings the user back to the local
 * onboarding page. Portal owns the canonical user profile, so this sync hop
 * is kept — the local wizard then only asks for personal info (role is
 * always USER).
 */
export function buildPortalInitialOnboardingUrl(): string {
  const returnUrl = new URL(
    `profile/onboarding?${PORTAL_PROFILE_COMPLETED}=true`,
    document.baseURI,
  ).toString();
  return `${environment.portalBaseUrl}/ui/secure/initial-onboarding?redirectUrl=`
    + encodeURIComponent(returnUrl);
}

/**
 * Portal owns the canonical user profile. Send the user through Portal's
 * profile setup and allow them back only after Portal returns with
 * `?portalProfileCompleted=true`.
 */
export const portalProfileOnboardingGuard: CanActivateFn = (route, state) => {
  if (route.queryParamMap.get(PORTAL_PROFILE_COMPLETED) === 'true') {
    return true;
  }

  const portalUrl = buildPortalInitialOnboardingUrl();

  console.warn(`[portalProfileOnboardingGuard] Blocked access to "${state?.url ?? '/profile/onboarding'}" (portal profile not completed). Redirecting to portal:`, portalUrl);
  window.location.assign(portalUrl);
  return false;
};
